export enum PaymentStatuses {
  PAID = "paid",
}

export type TBillingHistory = {
  id: string;
  amount: number;
  createdAt: string;
  currency: string;
  status: PaymentStatuses;
  planId: string;
  invoiceUrl: string;
  plan: string;
  number: string;
};

export type TBillingHistoryInitialState = {
  data: TBillingHistory[];
  isLoading: boolean;
  error: string | null;
  hasMore: boolean;
  total: number;
};
